import Boom from 'boom'
import makeApi from '../client/api'
import { authenticateCrawlerConversion } from './auth'

const fetchCrawlerData = async (announcementId, { source, sourceId, token }) => {
  const { accessToken } = await authenticateCrawlerConversion(announcementId, {
    source,
    sourceId,
    token,
  })
  const api = makeApi({ token: accessToken })

  const rawAnnouncement = await api.getOne('/announcements/raw', { id: announcementId })
  if (
    rawAnnouncement.approved === false ||
    rawAnnouncement.blacklisted ||
    rawAnnouncement.complete
  ) {
    throw Boom.notFound('Data unavailable')
  }

  const propertyAnnouncement = await api.getOne('/announcements/properties', {
    id: rawAnnouncement.announcement_id,
  })
  return { rawAnnouncement, propertyAnnouncement }
}

export default fetchCrawlerData
